export default function Styles(){
  return (
    <style>
      {`
       /* // @media (max-width: 410px) {
//   .xxs-size {
//     width: 95% !important;
//   }

//   .closeBtn {
//     display: none;
//   }
// }

// .xxs-size .rs-modal-dialog .rs-modal-content {
//   height: 90vh;
// } */
@media (max-width: 1100px) {
  .juctionModal .rs-modal-dialog .rs-modal-content {
    width: 85% !important;
  }
  
}
@media (max-width: 1024px) {
  .juctionModal .rs-modal-dialog .rs-modal-content {
    width: 88% !important;
  }

}
@media (max-width: 780px) {
  .juctionModal .rs-modal-dialog .rs-modal-content {
    width: 95% !important;
  }

}
@media (max-width: 520px) {
  .juctionModal .rs-modal-dialog .rs-modal-content {
    width: 100% !important;
  }

}
 

.juctionModal {
  position: fixed !important;
  /* // background: red !important; */
   background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.25) 100%),
   url("/static/images/landingPages/TheJuction/timeshedule.png") !important;

   background-repeat: no-repeat !important;
   background-size: cover !important;
  margin-top: 0 !important;
  width: 100% !important; 
  height: 100vh !important;
  top: 0 !important;
  left: 0 !important;
  z-index: 114 !important;
}
 .juctionModal::after {
   content: "";
   background: rgba(3, 3, 3, 0.9);
   -webkit-filter: blur(5px, 90%);
   -moz-filter: blur(8px, 90%);
   -o-filter: blur(8px, 90%);
   -ms-filter: blur(8px, 90%);
   filter: blur(8px, 90%);
   position: absolute;
   top: 0;
   left: 0;
   right: 0;
   bottom: 0;
   z-index: 0;
 }
.juctionModal .rs-modal-dialog .rs-modal-content {
   margin: 0 auto;
  /* //  min-width: 309px; */
  width: 80%;
  max-height: 90vh;
  z-index: 1 !important;
   border-radius: none !important;
   overflow: auto;
  background:  transparent;
   position: fixed;
   top: 50%;
   left: 50%;
   transform: translate(-50%, -50%);
   box-shadow: none !important;
   
}
.juctionModal .rs-modal-dialog .rs-modal-content .rs-modal-header .rs-modal-header-close {
  color: #ffffff !important;
  font-size: 20px !important;
  top: 3px !important;
}
.juctionCarousel .rec-carousel .rec-arrow-left {
  background-color:  #414141 !important;
  color: #ffffff !important;
  width: 40px !important;
  height: 40px !important;
  font-size: 1.5rem !important;
  min-width: 40px !important;
  line-height: 40px !important;
}
.juctionCarousel .rec-carousel .rec-arrow-right {
  width: 40px !important;
  height: 40px !important;
  font-size: 1.5rem !important;
  min-width: 40px !important;
  line-height: 40px !important;
  background-color: #414141 !important;
  color: #ffffff !important;
}
 .juctionCarousel .rec-carousel .rec-slider-container .rec-slider .rec .rec-carousel-item {
   display: flex !important;
   align-items: center !important;
 }
 .imgNo{
   font-size: 24px !important;
 }
        `}
    </style>
  );
}
